import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import ShimmerForProfileTabs from "../../components/Layouts/ShimmerForProfileTabs";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Page from "../../finwell/pages/Page";
import "./SessionNotes.scss";
import _ from "lodash";
import { SessionKeys, timezoneArea } from "../../utils/AppUtils";
import SessionNoteAddModal from "../../components/menu_detail/SessionNoteAddModal";
import {
  getSessionNotes,
  getSessionNotesClear,
} from "../../redux/coaching/actions";
import StaticUtils from "../../utils/StaticUtils";
import CoachRating from "./CoachRating";

const SessionNotes = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showAddCoachModal, setShowAddCoachModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [timezone, setTimezone] = useState({});
  const [coachingNoteData, setCoachingNoteData] = useState([]);
  const [filteredData, setFilteredData] = useState("");
  const [sessionStartDate, setSessionStartDate] = useState("");
  const [sessionStartTime, setSessionStartTime] = useState("");
  const [sessionEndDate, setSessionEndDate] = useState("null");
  const [sessionEndTime, setSessionEndTime] = useState("null");
  const [selectedPage, setSelectedPage] = useState(1);
  const [limit, setlimit] = useState("");
  const [pagination, setPagination] = useState({});
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [availableRecords, setAvailableRecords] = useState([]);
  const [coachDetails, setCoachDeatils] = useState({});

  const coachingSessionNotesListing = useSelector(
    (state) => state.coaching.sessionNotesList
  );
  const userDetailRes = useSelector((state) => state?.user?.userBroker);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let sessionId = "";
  let decodedString = atob(c);
  let paramsReq = JSON.parse(decodedString);
  sessionId = paramsReq.id;

  useEffect(() => {
    if (coachingNoteData?.length > 0) {
      setFilteredData(coachingNoteData);
      setPagination(coachingNoteData[0]?.pagination);
      setCoachDeatils(coachingNoteData[0]?.coach_details);
      const predefinedOptions = [10, 20, 30];
      const totalRecords = coachingNoteData[0]?.pagination?.totalRecords || "";
      const validOptions = predefinedOptions.filter(
        (value) => value <= totalRecords
      );
      if (totalRecords > Math.max(...validOptions)) {
        const nextOption = predefinedOptions.find(
          (value) => value > totalRecords
        );
        if (nextOption) {
          validOptions.push(nextOption);
        }
      }
      setAvailableRecords(validOptions);
    }
  }, [coachingNoteData]);

  useEffect(() => {
    if (filteredData[0]?.start_date) {
      // Check if timestamp is in seconds and convert to milliseconds if necessary
      const timestamp =
        filteredData[0].start_date.toString().length === 10
          ? filteredData[0].start_date * 1000
          : filteredData[0].start_date;
      const timezoneAbbr = userDetailRes?.payload?.payload.timezoneAbbr;

      // Convert timestamp to American timezone
      const sessionMoment = moment
        .unix(filteredData[0].start_date)
        .tz(timezoneAbbr);

      // Separate date and time
      setSessionStartDate(sessionMoment.format("DD MMMM, YYYY"));
      setSessionStartTime(sessionMoment.format("hh:mm A"));

      const endTimestamp =
        filteredData[0].end_date.toString().length === 10
          ? filteredData[0].end_date * 1000
          : filteredData[0].end_date;

      const endMoment = moment.unix(filteredData[0].end_date).tz(timezoneAbbr);
      setSessionEndDate(endMoment.format("DD MMMM, YYYY"));
      setSessionEndTime(endMoment.format("hh:mm A"));
    }
  }, [filteredData, userDetailRes]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsLoading(true);
    getCoachNotesDataReq();
  }, [localStorage.getItem(SessionKeys.API_TOKEN_BROKER)]);

  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      const offset = element.offsetTop; // Get the element's offset from the top of the page
      window.scrollTo({
        top: offset,
        behavior: "smooth", // Smooth scrolling animation
      });
    }
  };

  useEffect(() => {
    getCoachNotesDataReq();
    scrollToElement("cars");
  }, [entriesPerPage, selectedPage]);

  const handleChange = (event) => {
    const value = event.target.value;
    setEntriesPerPage(value);
    setSelectedPage(1);
    setSearchValue("");
  };

  const handlePageClick = (page) => {
    setSelectedPage(page);
    setSearchValue("");
  };

  const getCoachNotesDataReq = () => {
    setIsLoading(true);
    dispatch(
      getSessionNotes({
        module: "getCoachingSessionNotesData",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          coach_session_id: sessionId ? sessionId : "",
          page: selectedPage,
          limit: Number(entriesPerPage),
        },
      })
    );
  };

  useEffect(() => {
    console.log("coachingSessionNotesListing: ", coachingSessionNotesListing);
    if (!_.isEmpty(coachingSessionNotesListing)) {
      setIsLoading(false);
      if (coachingSessionNotesListing?.status === "success") {
        let list = coachingSessionNotesListing?.payload?.payload;
        setCoachingNoteData(list);
        dispatch(getSessionNotesClear());
      } else {
        setCoachingNoteData([]);
      }
    }
  }, [coachingSessionNotesListing]);

  const handleSearchChange = (evt) => {
    const value = evt.target.value;
    setSearchValue(value); // Update the search value

    // If search value is empty, return original data
    if (value.trim() === "") {
      setFilteredData(coachingNoteData); // Reset to original data
      return;
    }

    // Perform the filtering
    const result = coachingNoteData
      .map((item) => {
        // Filter resources in each item
        const filteredResources = item.resources.filter(
          (resource) =>
            resource?.notes?.toLowerCase().includes(value.toLowerCase()) ||
            resource?.files.some((file) =>
              file?.name?.toLowerCase().includes(value.toLowerCase())
            )
        );

        // Return a new object with filtered resources, or null if no resources match
        if (filteredResources.length > 0) {
          return {
            ...item,
            resources: filteredResources,
          };
        }
        return null; // If no match, exclude this item
      })
      .filter((item) => item !== null); // Remove null items (no match)
    setFilteredData(result); // Update the filteredData state
  };
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <Page>
      {/* <Loader start={isLoading} /> */}
      <section className="sessionnotes-from pt-4 pb-4">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <button className="mb-4 bck-btn" onClick={() => navigate(-1)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                  fill="none"
                >
                  <path
                    d="M7.42188 16.6262L0.273438 9.16523C0.078125 8.93086 0 8.69649 0 8.46211C0 8.2668 0.078125 8.03242 0.234375 7.83711L7.38281 0.376169C7.73438 -0.0144556 8.35938 -0.0144556 8.71094 0.337107C9.10156 0.688669 9.10156 1.27461 8.75 1.66523L2.22656 8.46211L8.78906 15.3371C9.14062 15.6887 9.14062 16.3137 8.75 16.6652C8.39844 17.0168 7.77344 17.0168 7.42188 16.6262Z"
                    fill="black"
                  />
                </svg>{" "}
                {t("back")}
              </button>
              <div className="d-flex gap-1 justify-content-between mb-5">
                <h1 className="lable-heading_search mb-0">
                  {`Session Notes${
                    filteredData[0]?.title ? ` (${filteredData[0]?.title})` : ""
                  }`}
                </h1>
                {coachDetails?.is_rating ? (
                  <div className="btn-sessions d-flex align-items-center gap-3">
                    <button
                      className="btn-primary d-flex gap-2 align-items-center"
                      onClick={handleShow}
                    >
                      Rate Your Coach
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_3328_67950)">
                          <path
                            d="M4.97643 19.998C4.7573 19.998 4.53971 19.9296 4.354 19.7953C4.00808 19.5446 3.84648 19.1137 3.94063 18.6979L5.22729 13.0302L0.863771 9.20349C0.543023 8.92349 0.420491 8.48005 0.552178 8.07431C0.683865 7.66933 1.04215 7.38261 1.46636 7.3434L7.23982 6.81925L9.52244 1.47746C9.69075 1.085 10.0741 0.831543 10.4999 0.831543C10.9258 0.831543 11.3091 1.085 11.4774 1.47655L13.7601 6.81925L19.5326 7.3434C19.9577 7.3817 20.316 7.66933 20.4477 8.07431C20.5794 8.47929 20.4576 8.92349 20.1369 9.20349L15.7734 13.0294L17.06 18.697C17.1543 19.1137 16.9926 19.5446 16.6468 19.7946C16.3018 20.0445 15.8417 20.0638 15.4784 19.8454L10.4999 16.8703L5.52148 19.8471C5.35317 19.947 5.16564 19.998 4.97643 19.998ZM10.4999 15.5887C10.6892 15.5887 10.8765 15.6395 11.045 15.7395L15.7435 18.5496L14.5291 13.2002C14.4425 12.8195 14.5717 12.422 14.8659 12.1644L18.986 8.55101L13.535 8.056C13.1425 8.02014 12.805 7.7734 12.6516 7.41176L10.4999 2.37074L8.34565 7.41252C8.19398 7.77172 7.85644 8.01846 7.46489 8.05432L2.01309 8.54933L6.13307 12.1627C6.42818 12.421 6.55728 12.8178 6.46984 13.1994L5.25643 18.5487L9.95489 15.7395C10.1232 15.6395 10.3107 15.5887 10.4999 15.5887ZM7.19572 6.92255C7.19572 6.92255 7.19572 6.92347 7.19481 6.92423L7.19572 6.92255ZM13.8025 6.92011L13.8034 6.92179C13.8034 6.92087 13.8034 6.92087 13.8025 6.92011Z"
                            fill="#415385"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_3328_67950">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(0.5 0.402344)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                    {/* <button
                  className="btn-primary active-page d-flex gap-2 align-items-center"
                >
                  Request New Session
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M19.5625 16.5093H19.2344V5.27682C19.2344 4.48245 18.5881 3.83624 17.7937 3.83624H14.8362C14.8362 3.83397 14.8375 3.83195 14.8375 3.82968C14.8375 3.74683 14.8045 3.66733 14.7456 3.60873L13.6674 2.5336C13.5453 2.41183 13.3479 2.41183 13.2258 2.53391L12.6936 3.06628C12.346 2.86029 11.9713 2.70496 11.5748 2.60257V1.84863C11.5748 1.67606 11.4351 1.53613 11.2623 1.53613H9.73767C9.56494 1.53613 9.42517 1.67606 9.42517 1.84863V2.60257C9.02875 2.70496 8.65399 2.86029 8.3064 3.06628L7.77417 2.53391C7.6521 2.41183 7.45465 2.41183 7.33258 2.5336L6.25439 3.60873C6.1955 3.66733 6.16254 3.74683 6.16254 3.82968C6.16254 3.83195 6.16376 3.83397 6.16383 3.83624H3.2063C2.41193 3.83624 1.76556 4.48245 1.76556 5.27682V16.5093H1.4375C1.26477 16.5093 1.125 16.6492 1.125 16.8218V17.7085C1.125 18.5688 1.82507 19.2687 2.68536 19.2687H18.3146C19.1749 19.2687 19.875 18.5688 19.875 17.7085V16.8218C19.875 16.6492 19.7352 16.5093 19.5625 16.5093ZM8.52063 17.1343H12.4794V17.5765H8.52063V17.1343ZM7.55292 3.19644L8.0415 3.68518C8.14771 3.79123 8.31403 3.80679 8.43793 3.72287C8.84595 3.44608 9.30371 3.2561 9.7984 3.15829C9.94458 3.1293 10.0502 3.00098 10.0502 2.85175V2.16113H10.9498V2.85175C10.9498 3.00098 11.0554 3.1293 11.2016 3.15829C11.6963 3.2561 12.1541 3.44608 12.5621 3.72287C12.6863 3.80695 12.8526 3.79153 12.9585 3.68518L13.4471 3.19644L14.0828 3.83029L13.5948 4.31842C13.5418 4.37139 13.5114 4.43944 13.5047 4.50978C13.498 4.58009 13.515 4.65266 13.5569 4.71469C13.7211 4.9567 13.8566 5.22189 13.9592 5.50143C14.0284 5.69385 14.0818 5.88733 14.1182 6.07654C14.1465 6.22363 14.2753 6.32999 14.4252 6.32999H15.1155V7.22675H14.4252C14.275 7.22675 14.1462 7.3334 14.1182 7.48065C14.0242 7.97412 13.8353 8.43204 13.5573 8.84189C13.473 8.96594 13.4886 9.13226 13.5948 9.23831L14.0828 9.72644L13.4468 10.3606L12.9582 9.87415C12.852 9.76886 12.6869 9.75284 12.5633 9.83615C12.1464 10.1158 11.689 10.3049 11.2034 10.3981C11.0563 10.4264 10.9498 10.5551 10.9498 10.705V11.3956H10.0502V10.705C10.0502 10.5551 9.94366 10.4264 9.79657 10.3981C9.31104 10.3049 8.85358 10.1158 8.43671 9.83615C8.31281 9.75284 8.14771 9.76886 8.04181 9.87415L7.55322 10.3606L6.91724 9.72644L7.40521 9.23831C7.51141 9.13226 7.52698 8.96594 7.44275 8.84189C7.16473 8.43204 6.97583 7.97412 6.88184 7.48065C6.85376 7.3334 6.72498 7.22675 6.57483 7.22675H5.88452V6.32999H6.57483C6.72467 6.32999 6.85345 6.22363 6.88184 6.07654C6.91808 5.88767 6.97141 5.69453 7.04053 5.50246C7.14368 5.22151 7.27902 4.9565 7.44305 4.71469C7.48502 4.65266 7.50203 4.58009 7.49532 4.50978C7.4886 4.43944 7.45816 4.37139 7.40521 4.31842L6.91724 3.83029L7.55292 3.19644ZM15.4719 5.70804H17.0405C17.1663 5.70804 17.2688 5.81042 17.2688 5.93616V15.033C17.2688 15.1587 17.1663 15.2611 17.0405 15.2611H3.95947C3.83374 15.2611 3.7312 15.1587 3.7312 15.033V5.93616C3.7312 5.81042 3.83374 5.70804 3.95947 5.70804H5.52808C5.51205 5.71029 5.49847 5.71832 5.48333 5.7229C5.46773 5.72761 5.45224 5.731 5.43778 5.738C5.41661 5.74821 5.39868 5.76215 5.38045 5.77666C5.36855 5.78613 5.3558 5.7937 5.34543 5.80476C5.32803 5.82332 5.31556 5.84531 5.30305 5.86768C5.29668 5.87907 5.28802 5.88853 5.2831 5.90074C5.26841 5.93694 5.25952 5.976 5.25952 6.01749V7.53925C5.25952 7.71182 5.39929 7.85175 5.57202 7.85175H6.32428C6.42468 8.24863 6.57941 8.6243 6.78632 8.97342L6.25409 9.5058C6.13202 9.62787 6.13202 9.82562 6.25409 9.94769L7.33258 11.0231C7.36302 11.0535 7.39819 11.0762 7.43569 11.0914C7.54826 11.1371 7.68208 11.1145 7.77386 11.0231L8.3067 10.4926C8.65857 10.7003 9.03302 10.8551 9.42517 10.9552V11.7081C9.42517 11.8807 9.56494 12.0206 9.73767 12.0206H11.2623C11.4351 12.0206 11.5748 11.8807 11.5748 11.7081V10.9552C11.967 10.8551 12.3414 10.7003 12.6933 10.4926L13.2261 11.0231C13.3177 11.1145 13.4515 11.137 13.5641 11.0914C13.6017 11.0762 13.6369 11.0534 13.6674 11.0231L14.7459 9.94769C14.868 9.82562 14.868 9.62787 14.7459 9.5058L14.2137 8.97342C14.4206 8.6243 14.5753 8.24863 14.6757 7.85175H15.428C15.6007 7.85175 15.7405 7.71182 15.7405 7.53925V6.01749C15.7405 5.97602 15.7316 5.93698 15.7169 5.90079C15.712 5.88851 15.7032 5.87894 15.6968 5.86747C15.6843 5.84518 15.672 5.82326 15.6546 5.80478C15.6442 5.7937 15.6315 5.78613 15.6196 5.77665C15.6013 5.76215 15.5834 5.74823 15.5623 5.73802C15.5478 5.73102 15.5323 5.72759 15.5166 5.72288C15.5015 5.7183 15.4879 5.71029 15.4719 5.70804ZM2.39056 5.27682C2.39056 4.82715 2.75647 4.46124 3.2063 4.46124H6.66425L6.78662 4.58362C6.69278 4.74256 6.61275 4.91086 6.53947 5.08304H3.95947C3.48889 5.08304 3.1062 5.46573 3.1062 5.93616V15.033C3.1062 15.5034 3.48889 15.8861 3.95947 15.8861H17.0405C17.5111 15.8861 17.8938 15.5034 17.8938 15.033V5.93616C17.8938 5.46573 17.5111 5.08304 17.0405 5.08304H14.4606C14.3875 4.91105 14.3074 4.74275 14.2134 4.58362L14.3358 4.46124H17.7937C18.2435 4.46124 18.6094 4.82715 18.6094 5.27682V16.5081H2.39056V5.27682ZM19.25 17.7085C19.25 18.2242 18.8304 18.6437 18.3146 18.6437H2.68536C2.16962 18.6437 1.75 18.2242 1.75 17.7085V17.1343H7.89563V17.889C7.89563 18.0616 8.0354 18.2015 8.20813 18.2015H12.7919C12.9646 18.2015 13.1044 18.0616 13.1044 17.889V17.1343H19.25V17.7085Z" fill="white"/>
                    <path d="M10.4999 9.48447C11.9913 9.48447 13.2043 8.27124 13.2043 6.78C13.2043 5.28891 11.9913 4.07568 10.4999 4.07568C9.00848 4.07568 7.79541 5.28891 7.79541 6.78C7.79541 8.27124 9.00848 9.48447 10.4999 9.48447ZM10.4999 4.70068C11.6464 4.70068 12.5793 5.63345 12.5793 6.78C12.5793 7.92654 11.6464 8.85947 10.4999 8.85947C9.35333 8.85947 8.42041 7.92654 8.42041 6.78C8.42041 5.63345 9.35333 4.70068 10.4999 4.70068Z" fill="white"/>
                    <path d="M13.0743 12.9023H12.792C12.6193 12.9023 12.4795 13.0423 12.4795 13.2148C12.4795 13.3874 12.6193 13.5273 12.792 13.5273H13.0743C13.247 13.5273 13.3868 13.3874 13.3868 13.2148C13.3868 13.0423 13.247 12.9023 13.0743 12.9023Z" fill="white"/>
                    <path d="M13.6289 13.2148C13.6289 13.3874 13.7687 13.5273 13.9414 13.5273H16.4011C16.5739 13.5273 16.7136 13.3874 16.7136 13.2148C16.7136 13.0423 16.5739 12.9023 16.4011 12.9023H13.9414C13.7687 12.9023 13.6289 13.0423 13.6289 13.2148Z" fill="white"/>
                    <path d="M16.401 13.9102H14.0786C13.9059 13.9102 13.7661 14.0501 13.7661 14.2227C13.7661 14.3952 13.9059 14.5352 14.0786 14.5352H16.401C16.5737 14.5352 16.7135 14.3952 16.7135 14.2227C16.7135 14.0501 16.5737 13.9102 16.401 13.9102Z" fill="white"/>
                    <path d="M7.82837 12.9023H4.50195C4.32922 12.9023 4.18945 13.0423 4.18945 13.2148C4.18945 13.3874 4.32922 13.5273 4.50195 13.5273H7.82837C8.0011 13.5273 8.14087 13.3874 8.14087 13.2148C8.14087 13.0423 8.0011 12.9023 7.82837 12.9023Z" fill="white"/>
                    <path d="M6.73981 13.9526H4.50195C4.32922 13.9526 4.18945 14.0926 4.18945 14.2651C4.18945 14.4377 4.32922 14.5776 4.50195 14.5776H6.73981C6.91254 14.5776 7.05231 14.4377 7.05231 14.2651C7.05231 14.0926 6.91254 13.9526 6.73981 13.9526Z" fill="white"/>
                  </svg>
                </button> */}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="s-earch-and-filters d-flex gap-3 justify-content-between mb-4 flex-column flex-md-row">
              <div className="search-filter position-relative">
                <input
                  type="search"
                  placeholder={t("Search")}
                  id="inputPassword2"
                  className="form-control"
                  value={searchValue}
                  onChange={handleSearchChange}
                />
              </div>
              <div className="filter-section">
                <div className="filter-option-listing d-flex justify-content-end gap-3">
                  <button
                    className="btn-primary d-flex gap-2 align-items-center"
                    onClick={() => {
                      setShowAddCoachModal(true);
                    }}
                  >
                    Add Notes
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_3328_67912)">
                        <path
                          d="M8.01667 17.707H2.58333C1.435 17.707 0.5 16.7729 0.5 15.6237V2.29036C0.5 1.1412 1.435 0.207031 2.58333 0.207031H12.5833C13.7317 0.207031 14.6667 1.1412 14.6667 2.29036V7.34036C14.6667 7.57036 14.48 7.75703 14.25 7.75703C14.02 7.75703 13.8333 7.57036 13.8333 7.34036V2.29036C13.8333 1.6012 13.2725 1.04036 12.5833 1.04036H2.58333C1.89417 1.04036 1.33333 1.6012 1.33333 2.29036V15.6237C1.33333 16.3129 1.89417 16.8737 2.58333 16.8737H8.01667C8.24667 16.8737 8.43333 17.0604 8.43333 17.2904C8.43333 17.5204 8.24667 17.707 8.01667 17.707Z"
                          fill="#135591"
                          stroke="#135591"
                          stroke-width="0.3"
                        />
                        <path
                          d="M11.75 7.70687H3.41667C3.18667 7.70687 3 7.5202 3 7.2902C3 7.0602 3.18667 6.87354 3.41667 6.87354H11.75C11.98 6.87354 12.1667 7.0602 12.1667 7.2902C12.1667 7.5202 11.98 7.70687 11.75 7.70687Z"
                          fill="#135591"
                          stroke="#135591"
                          stroke-width="0.3"
                        />
                        <path
                          d="M8.41667 11.0404H3.41667C3.18667 11.0404 3 10.8537 3 10.6237C3 10.3937 3.18667 10.207 3.41667 10.207H8.41667C8.64667 10.207 8.83333 10.3937 8.83333 10.6237C8.83333 10.8537 8.64667 11.0404 8.41667 11.0404Z"
                          fill="#135591"
                          stroke="#135591"
                          stroke-width="0.3"
                        />
                        <path
                          d="M7.58333 4.37386H3.41667C3.18667 4.37386 3 4.18719 3 3.95719C3 3.72719 3.18667 3.54053 3.41667 3.54053H7.58333C7.81333 3.54053 8 3.72719 8 3.95719C8 4.18719 7.81333 4.37386 7.58333 4.37386Z"
                          fill="#135591"
                          stroke="#135591"
                          stroke-width="0.3"
                        />
                        <path
                          d="M15.0832 20.2069C12.0965 20.2069 9.6665 17.7769 9.6665 14.7902C9.6665 11.8035 12.0965 9.37354 15.0832 9.37354C18.0698 9.37354 20.4998 11.8035 20.4998 14.7902C20.4998 17.7769 18.0698 20.2069 15.0832 20.2069ZM15.0832 10.2069C12.5557 10.2069 10.4998 12.2635 10.4998 14.7902C10.4998 17.3169 12.5557 19.3735 15.0832 19.3735C17.6107 19.3735 19.6665 17.3169 19.6665 14.7902C19.6665 12.2635 17.6107 10.2069 15.0832 10.2069Z"
                          fill="#135591"
                          stroke="#135591"
                          stroke-width="0.3"
                        />
                        <path
                          d="M15.0832 17.7069C14.8532 17.7069 14.6665 17.5202 14.6665 17.2902V12.2902C14.6665 12.0602 14.8532 11.8735 15.0832 11.8735C15.3132 11.8735 15.4998 12.0602 15.4998 12.2902V17.2902C15.4998 17.5202 15.3132 17.7069 15.0832 17.7069Z"
                          fill="#135591"
                          stroke="#135591"
                          stroke-width="0.3"
                        />
                        <path
                          d="M17.5832 15.2069H12.5832C12.3532 15.2069 12.1665 15.0202 12.1665 14.7902C12.1665 14.5602 12.3532 14.3735 12.5832 14.3735H17.5832C17.8132 14.3735 17.9998 14.5602 17.9998 14.7902C17.9998 15.0202 17.8132 15.2069 17.5832 15.2069Z"
                          fill="#135591"
                          stroke="#135591"
                          stroke-width="0.3"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_3328_67912">
                          <rect
                            width="20"
                            height="20"
                            fill="white"
                            transform="translate(0.5 0.207031)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            {filteredData[0]?.resources?.length > 0 ? (
              <div className="uni-selct d-flex align-items-center gap-2">
                <select
                  name="cars"
                  id="cars"
                  className="form-select w-auto p-2 pe-5"
                  value={entriesPerPage}
                  onChange={handleChange}
                >
                  {availableRecords.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                <label htmlFor="cars" className="">
                  Entries per page
                </label>
              </div>
            ) : (
              ""
            )}

            <div className="profile-info-wrapper">
              <div className="course-info-table">
                <table className="table mb-0 office_list table-striped video-list">
                  <thead>
                    <tr>
                      <th style={{ minWidth: "200px" }}>{t("Notes")}</th>
                      <th>Uploaded Date</th>
                      <th>Documents</th>
                      <th>Author</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr className="not-found">
                        <td colSpan={5}>
                          {[1, 2, 3, 4, 5, 6, 7, 8].map((m) => {
                            return (
                              <ShimmerForProfileTabs
                                key={`notify-${m}-shimmer`}
                              />
                            );
                          })}
                        </td>
                      </tr>
                    ) : filteredData &&
                      filteredData[0]?.resources?.length > 0 ? (
                      filteredData &&
                      filteredData[0]?.resources?.map((resource, index) => {
                        const uploadedDate = moment
                          .unix(resource.date)
                          .tz(userDetailRes?.payload?.payload?.timezoneAbbr)
                          .format("Do MMM YYYY");
                        return (
                          <tr>
                            <td
                              className="cursor-pointer"
                              title={resource.notes}
                              style={{ maxWidth: "14rem" }}
                            >
                              <span>
                                {resource?.notes?.length > 85
                                  ? `${resource.notes.slice(0, 85)}...`
                                  : resource.notes}
                              </span>
                            </td>
                            {/* <td>{moment.unix(item.date).tz(userDetailRes?.payload?.payload?.timezoneAbbr)}</td> */}
                            <td>{uploadedDate}</td>
                            <td className="fielsd" style={{ maxWidth: "5rem" }}>
                              <div className="d-flex gap-2 flex-wrap difld">
                                {resource?.files?.length > 0 ? (
                                  resource.files.map((doc, idx) => (
                                    <div key={idx} className="file-container">
                                      <a
                                        href={doc?.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="file-link"
                                      >
                                        <div className="upload-ciox">
                                          {doc.name?.includes(".pdf") && (
                                            <img
                                              className="img-design"
                                              src="/images/pdf_icon.svg"
                                              alt="PDF Icon"
                                              loading="lazy"
                                            />
                                          )}
                                          {(doc.name?.includes(".docx") ||
                                            doc.name?.includes(".doc")) && (
                                            <img
                                              className="img-design"
                                              src="/images/doc_icon.svg"
                                              alt="Word Icon"
                                              loading="lazy"
                                            />
                                          )}
                                          {(doc.name?.includes(".pptx") ||
                                            doc.name?.includes(".ppt")) && (
                                            <img
                                              className="img-design"
                                              src="/images/pptx_1.svg"
                                              alt="PowerPoint Icon"
                                              loading="lazy"
                                            />
                                          )}
                                          {(doc.name?.includes(".xlsx") ||
                                            doc.name?.includes(".xls")) && (
                                            <img
                                              className="img-design"
                                              src="/images/xlsx_1.svg"
                                              alt="Excel Icon"
                                              loading="lazy"
                                            />
                                          )}
                                        </div>
                                        <div className="text-vx"></div>
                                      </a>
                                    </div>
                                  ))
                                ) : (
                                  <p>No files uploaded.</p> // Message when no files are present
                                )}
                              </div>
                            </td>
                            <td className="fielsd">{resource?.user_name}</td>

                            {/* <td className="text-center">
                              <span
                                className="cursor-pointer"
                                onClick={() => {
                                  setConfirmModal(true);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="24"
                                  height="24"
                                  fill="rgba(255,0,0,1)"
                                >
                                  <path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"></path>
                                </svg>
                              </span>
                            </td> */}
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="not-found">
                        <td colSpan={5}>
                          <img
                            src="/images/finwell-img/NoSearchResults.svg"
                            alt="Not Found"
                            loading="lazy"
                          />
                          <p>No session notes yet.</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {filteredData[0]?.resources?.length > 0 ? (
            <div className="pagination-container">
              {pagination?.totalPages > 1 && (
                <>
                  {/* Previous Button */}
                  <button
                    onClick={() =>
                      selectedPage > 1 && handlePageClick(selectedPage - 1)
                    }
                    className="pagination-item pagination-arrow"
                    disabled={selectedPage === 1}
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from(
                    { length: Math.min(5, pagination?.totalPages) },
                    (_, i) => {
                      const startPage = Math.max(
                        1,
                        Math.min(
                          selectedPage - Math.floor(5 / 2),
                          pagination?.totalPages - 5 + 1
                        )
                      );
                      return startPage + i;
                    }
                  ).map((page) => (
                    <button
                      key={page}
                      onClick={() => handlePageClick(page)}
                      className="pagination-item"
                      style={{
                        backgroundColor:
                          selectedPage === page ? "#475467" : "#ffffff",
                        color: selectedPage === page ? "white" : "",
                      }}
                    >
                      {page}
                    </button>
                  ))}

                  {/* Next Button */}
                  <button
                    onClick={() =>
                      selectedPage < pagination?.totalPages &&
                      handlePageClick(selectedPage + 1)
                    }
                    className="pagination-item pagination-arrow"
                    disabled={selectedPage === pagination?.totalPages}
                  >
                    Next
                  </button>
                </>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      </section>

      {showAddCoachModal ? (
        <SessionNoteAddModal
          showAddCoachModal={showAddCoachModal}
          setShowAddCoachModal={setShowAddCoachModal}
          refreshList={[]}
          timezone={timezone}
          getCoachNotesDataReq={getCoachNotesDataReq}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          sessionId={sessionId}
          sessionStartDate={sessionStartDate}
          sessionStartTime={sessionStartTime}
          sessionEndTime={sessionEndTime}
        />
      ) : (
        ""
      )}
      {/* {confirmModal && (
        <ConfirmModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          showModalMsg={t("Are you sure you want to delete?")}
          isConfirm={true}
          confirmId={""}
          confirmAction={""}
          noAction={() => {}}
        />
      )} */}
      <CoachRating
        show={show}
        handleClose={handleClose}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        coachId={coachDetails?.id}
        coachName={coachDetails?.name}
        coachImage={coachDetails?.image}
        coachDesignation={coachDetails?.designation}
        coachExperience={coachDetails?.experience}
        sessionNotes={true}
        getCoachNotesDataReq={getCoachNotesDataReq}
        entityType={"coach"}
      />
    </Page>
  );
};

export default SessionNotes;
